import axios from 'axios';

const state = {};
const getters = {};
const mutations = {};

const actions = {
  async getBulkMessages(_obj, params) {
    const res = await axios.get(`api/organizations/bulk-messages/`, { params });
    return res.data;
  },

  async getBulkMessage(_obj, id) {
    const res = await axios.get(`api/organizations/bulk-messages/${id}/`);
    return res.data;
  },

  async createBulkMessage(_obj, data) {
    return axios.post(`api/organizations/bulk-messages/`, data);
  },

  async getBulkMessageEmailLogs(_obj, { id, params }) {
    const res = await axios.get(`api/organizations/bulk-messages/${id}/email-logs/`, { params });
    return res.data;
  },

  async getBulkMessageSmsLogs(_obj, { id, params }) {
    const res = await axios.get(`api/organizations/bulk-messages/${id}/sms-logs/`, { params });
    return res.data;
  },

  async getAvailableTags() {
    const res = await axios.get(`api/organizations/bulk-messages/available-tags/`);
    return res.data;
  },

  async getAvailablePrograms() {
    const res = await axios.get(`api/organizations/bulk-messages/available-programs/`);
    return res.data;
  },

  async getEmailReplies(_obj, params) {
    const res = await axios.get(`api/organizations/email-replies/threaded-list/`, { params });
    return res.data;
  },

  async getEmailThread(_obj, { senderEmail, bulkMessageId }) {
    const params = {
      sender_email: senderEmail,
      bulk_message: bulkMessageId
    };
    const res = await axios.get(`api/organizations/email-replies/threaded-list/`, { params });
    return res.data;
  },

  async replyToEmailThread(_obj, { id, body }) {
    const res = await axios.post(`api/organizations/email-replies/${id}/reply/`, { body });
    return res.data;
  },

  async markEmailReplyRead(_obj, id) {
    const res = await axios.patch(`api/organizations/email-replies/${id}/mark-read/`);
    return res.data;
  },

  async getSmsRepliesThreadedList(_obj, params) {
    const res = await axios.get(`api/organizations/sms-replies/threaded-list/`, { params });
    return res.data;
  },

  async getSmsReply(_obj, id) {
    const res = await axios.get(`api/organizations/sms-replies/${id}/`);
    return res.data;
  },

  async replyToSmsReply(_obj, { id, body }) {
    const res = await axios.post(`api/organizations/sms-replies/${id}/reply/`, { body });
    return res.data;
  },

  async markSmsReplyRead(_obj, id) {
    const res = await axios.patch(`api/organizations/sms-replies/${id}/mark-read/`);
    return res.data;
  },

  async getSmsConversations(_obj, params) {
    const res = await axios.get(`api/organizations/sms-conversations/`, { params });
    return res.data;
  },

  async getSmsConversation(_obj, id) {
    const res = await axios.get(`api/organizations/sms-conversations/${id}/`);
    return res.data;
  },

  async getSmsConversationMessages(_obj, { id, params }) {
    const res = await axios.get(`api/organizations/sms-conversations/${id}/messages/`, { params });
    return res.data;
  },

  async replyToSmsConversation(_obj, { id, body }) {
    const res = await axios.post(`api/organizations/sms-conversations/${id}/reply/`, { body });
    return res.data;
  },

  async markSmsConversationRead(_obj, id) {
    const res = await axios.patch(`api/organizations/sms-conversations/${id}/mark-read/`);
    return res.data;
  },

  async getSmsConversationsUnreadCount() {
    const res = await axios.get(`api/organizations/sms-conversations/unread-count/`);
    return res.data;
  },



  async getBulkMessageDashboardStudents(_obj, params) {
    const res = await axios.get(`api/organizations/bulk-messages/dashboard-students/`, { params });
    return res.data;
  },
};

export const bulkMessaging = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
